import React from 'react';

import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

interface IProps {
    isWide: boolean,
    title: string,
    image: {
        url: string,
        urlWebp?: string,
    },
}

const Advantage = ({ isWide, image: { url, urlWebp }, title }: IProps): JSX.Element => {
    return (
        <ST.AdvantageWrapper
            isWide={isWide}
            rounder={{ $radius: 24 }}
            indent={{ $desktop: [24], $mobile: [16] }}
            bgColor={COLORS.BgSurface}
        >
            <FullWidthListContainer
                $direction={isWide ? 'row' : 'column'}
                $alignItems={isWide ? 'center' : 'baseline'}
                $wrap={'nowrap'}
                $desktop={16}
                $mobile={8}
            >
                <ST.AdvantageImage>
                    <WebpImage urlWebp={urlWebp}>
                        <img src={url} alt={title}/>
                    </WebpImage>
                </ST.AdvantageImage>
                <ST.Description dangerouslySetInnerHTML={{ __html: title }}/>
            </FullWidthListContainer>
        </ST.AdvantageWrapper>
    );
};

export default Advantage;
